import React from 'react';
import '../styles.css';
import { Link } from 'react-router-dom';

function AppBar(props) {
    return (
        <div className='appBar'>
            <Link to={'/' + props.backTo} style={{ textDecoration: 'none' }}>
                <div className='appBarBackButton'>
                    {props.displayText}
                </div>
            </Link>
            <b>{props.name}</b>
            <div className='appBarCopyright'>
                decodeLabs 2021
            </div>
        </div>
    );
}

export default AppBar;